export default __webpack_public_path__ + "static/media/GitIcon.836d3107.JPG";